import { render, staticRenderFns } from "./dup-detail.vue?vue&type=template&id=689afcb4"
import script from "./dup-detail.vue?vue&type=script&lang=js"
export * from "./dup-detail.vue?vue&type=script&lang=js"
import style0 from "./dup-detail.vue?vue&type=style&index=0&id=689afcb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports